import * as PIXI from "pixi.js";
import {Animatable} from "./Animatable";
import * as AssetHelpers from "./AssetHelpers";
import {ContainerExtensions} from "./ContainerExtensions";
import {Mix} from "./Reflection";

export type Margin = { top?: number, left?: number, right?: number, bottom?: number } | number;

export class NineSlicePlane extends Mix(PIXI.mesh.NineSlicePlane, ContainerExtensions, Animatable) {

    private _nineSlice?: Margin;

    constructor(texture?: PIXI.Texture | string | Margin, slice?: Margin) {
        super(texture instanceof PIXI.Texture ? texture :
            typeof texture === "string" ? AssetHelpers.texture(texture) : PIXI.Texture.EMPTY);
        this.nineSlice = slice !== undefined ? slice :
            !(texture instanceof PIXI.Texture) && !(typeof texture === "string") ? texture : undefined;
    }

    public setScaleByWidth() {
        const scale = this.width / this.texture.width;
        this.scale.set(scale);
        this.width = this.texture.width;
        this.height /= scale;
    }

    public setScaleByHeight() {
        const scale = this.height / this.texture.height;
        this.scale.set(scale);
        this.height = this.texture.height;
        this.width /= scale;
    }

    set nineSlice(slice: Margin | undefined) {
        this._nineSlice = slice;
        this.updateNineSlice();
    }

    get nineSlice(): Margin | undefined {
        return this._nineSlice;
    }

    public updateNineSlice() {
        const slice = this._nineSlice;
        this.topHeight = (typeof slice === "number" ? slice : slice ? slice.top || 0 : 0) * this.texture.height;
        this.leftWidth = (typeof slice === "number" ? slice : slice ? slice.left || 0 : 0) * this.texture.width;
        this.rightWidth = (typeof slice === "number" ? slice : slice ? slice.right || 0 : 0) * this.texture.width;
        this.bottomHeight = (typeof slice === "number" ? slice : slice ? slice.bottom || 0 : 0) * this.texture.height;
    }

    public destroy(options?: PIXI.DestroyOptions | boolean): void {
        this.killTweens();
        this.cacheAsBitmap = false;
        super.destroy(options);
    }
}
